import './index.scss'
import '../../assets/scripts/myNiceScroll'
import {resizeScroll} from '../../assets/scripts/myNiceScroll'

//顶部搜索
$('.section1 .right .form-item input').on('click',function(){
  $(this).parents('.form-item').addClass('active').siblings().removeClass('active')
})
$('body').on('click',function(e){
  if($(e.target).parents('.section1 .right .form-item .form-cont').length == 0){
    $('.section1 .right .form-item').removeClass('active')
  }
})
// $('.section1 .right .form-item:nth-child(1)').on('click','.form-select a',function(){
//   let value = $(this).attr('data-value')
//   $(this).parents('.form-item').removeClass('active').find('input').val(value)
// })
// $('.section1 .right .form-item:nth-child(3)').on('click','.form-select a',function(){
//   let value = $(this).attr('data-value')
//   $(this).parents('.form-item').removeClass('active').find('input').val(value)
// })
// $('.section1 .right .form-btn button').on('click',function(){
//   let ScrollT = $('.section3').offset().top
//   $("html, body").animate({
//     scrollTop: ScrollT + 'px'
//   }, {
//       duration: 500,
//       easing: "swing"
//   });
//   return false;
// })

$(document).scroll(function () {
  $('.section1 .right .form-item').removeClass('active')
});



// 搜索列表搜索效果
//鼠标经过显示子菜单
var mouseover_tid = [];
var mouseout_tid = [];
$(document).ready(function () {
  $(".common-search-bar .search-bar .left-nav ul li").each(function (index) {
    $(this).hover(
      // 鼠标进入
      function () {
        var _self = this;
        // 停止卷起事件
        clearTimeout(mouseout_tid[ index ]);
        // 当鼠标进入超过 0.2 秒, 展开菜单, 并记录到线程 ID 中
        mouseover_tid[ index ] = setTimeout(function () {
          $(_self).addClass('show');
        }, 201);
      },
      // 鼠标离开
      function () {
        var _self = this;
        // 停止展开事件
        clearTimeout(mouseover_tid[ index ]);
        // 当鼠标离开超过 0.2 秒, 卷起菜单, 并记录到线程 ID 中
        mouseout_tid[ index ] = setTimeout(function () {
          $(_self).removeClass('show');
        }, 201);
      });
    });
});


//点击子菜单子项，添加横线，显示loading，添加tag
$('.common-search-bar .search-bar .left-nav ul li .sub-nav a').on('click',function(){
  // $(this).addClass('on')
  // $('.loading').fadeIn(300)
  // $('.common-search-bar .search-bar .left-nav ul li').removeClass('show')

  // let tag = $(this).attr('data-value')
  // let html = `<div class="tag">
  //               <span>${tag}</span>
  //               <i class="iconfont icon-guanbi"></i>
  //             </div>`
  // $('.common-search-bar .search-tag').append(html)

  resizeScroll()

  // setTimeout(function(){
  //   $('.loading').fadeOut(300)
  // },800)
})

//点击tag叉号，删除tag，删除子菜单子项横线
$('.common-search-bar .search-tag').on('click','.tag .iconfont',function(){
  // $(this).parents('.tag').remove()
  resizeScroll()

  // let value = $(this).siblings('span').html()
  // $('.common-search-bar .search-bar .left-nav ul li .sub-nav a[data-value='+ value +']').removeClass('on')
})